'use strict';

const angular = require('angular');

module.exports = angular.module('spinnaker.core.pipeline.stage.runJob', [
  require('./runJobStage.js').name,
]);



// WEBPACK FOOTER //
// ./app/scripts/modules/core/src/pipeline/config/stages/runJob/runJobStage.module.js